<template>
  <form class="costBaseForm grid-12" onsubmit="return false" @submit="send">
    <div class="row wrap justify-around column-s">
      <div class="column grid-3 grid-12-s">
        <label>Nome</label>
        <input v-model="form.nome" placeholder="Nome" required />
      </div>
    </div>

    <div v-if="form.nome_criado_por" class="info row wrap column-s justify-around">
      <div class="text-center grid-6 grid-12-s">
        <label>Criado por</label>
        <div>{{ form.nome_criado_por }} em {{ form.criado_em | date }}</div>
      </div>
      <div class="text-center grid-6 grid-12-s" v-if="form.nome_alterado_por">
        <label>Alterado por</label>
        <div>{{ form.nome_alterado_por }} em {{ form.alterado_em | date }}</div>
      </div>
    </div>

    <div class="controls row justify-center">
      <br /><br />
      <Button type="submit" :loader="loader" layout="green-go"
        ><i class="fa fa-edit" />{{ form.update ? "ATUALIZAR" : "ADICIONAR" }}</Button
      >&nbsp;&nbsp;&nbsp;
      <Button
        v-if="form.update"
        type="button"
        @click="del"
        :loader="loader"
        layout="red-go"
        ><i class="fa fa-trash" /> APAGAR</Button
      >
    </div>
  </form>
</template>

<script>
import Button from "@/components/Button.vue";

export default {
  name: "CostBaseForm",
  components: { Button },
  props: { form: Object },
  data() {
    return {
      loader: false,
    };
  },
  methods: {
    async send() {
      this.loader = true;
      await this.form.send(this.form);
      this.loader = false;
    },
    del() {
      this.loader = true;
      this.form
        .del(this.form)
        .then(() => (this.loader = false))
        .catch(() => (this.loader = false));
    },
  },
};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.costBaseForm
  @include form
</style>
